window.addEventListener('DOMContentLoaded', async () => {


    let postalCode = window.localStorage.getItem('mt_cp')
    if (!postalCode) {
        displayError()
        return
    }

    const content = await searchContent(postalCode)
    if (content) {
        if (Object.values(content).some(item => item.data && item.data.length > 0)) {
            dispatchHomeEvents(content)
        } else {
            if (document.getElementById('home-sections')) {
                document.getElementById('home-sections').innerHTML = 'Lo sentimos, no hemos encontrado ningún mercado o plaza cercana a tu ubicación'
            }
        }
    }

})

const createHomeSection = (data) => {

    if (data.data.length == 0) return

    const section = document.createElement('section')
    section.className = 'w-full'

    const sectionHeader = document.createElement('header')
    const headerHeading = document.createElement('h2')
    headerHeading.className = 'font-semibold text-xl'
    headerHeading.innerHTML = data.title

    sectionHeader.appendChild(headerHeading)
    section.appendChild(sectionHeader)

    const sectionMain = document.createElement('main')
    section.appendChild(sectionMain)

    document.getElementById('home-sections').appendChild(section)
}


const displayError = (errorMessage = null) => {
    const homeSections = document.getElementById('home-sections')
    const errorContainer = document.getElementById('general-error-home-container')
    if (errorContainer) {
        errorContainer.classList.remove('hidden')
        errorContainer.classList.add('flex')

        errorContainer.children[0].innerHTML = errorMessage ?? 'Ha ocurrido un error. Por favor, intentalo más tarde'

        homeSections.innerHTML = ''
    }
}


const searchContent = async (postalCode, extraParams = {}) => {
    try {
        const params = new URLSearchParams({ cp: postalCode, ...extraParams })
        const url = `${GET_DATA_URL}?${params.toString()}`

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        })

        const responseData = await response.json()
        if (response.status != 200) {
            throw new Error(responseData.message)
        }
        return responseData
    } catch (error) {
        displayError(error.message)
        return null
    }
}

const dispatchHomeEvents = (content) => {
    Object.keys(content).forEach((key) => {
        if (content[key].data.length == 0) {
            document.getElementById(content[key].sectionId)?.classList.add('hidden')
            return
        }
        document.getElementById(content[key].sectionId)?.classList.remove('hidden')
        window.dispatchEvent(new CustomEvent(content[key].eventName, {
            detail: content[key].data
        }))
    })
}

// Expuesto globalmente para que searchbar.js lo llame al cambiar filtros
window.reloadHomeContent = async (extraParams = {}) => {
    const postalCode = window.localStorage.getItem('mt_cp')
    if (!postalCode) return
    const content = await searchContent(postalCode, extraParams)
    if (content) dispatchHomeEvents(content)
}

